import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/24/outline";
import styles from "./nav.module.scss";
import { useContext } from "react";
import { SidebarContext } from "@/providers/sidebar-context";
import NavLinks from "./nav-links";
import SponsorLogosSidenav from "../home/sponsor-logos/sponsor-logos-sidenav";

const Sidebar = () => {
  const { isCollapsed, toggleSidebarcollapse } = useContext(SidebarContext);

  return (
    <div className={styles.sidebarWrapper}>
      <button
        className={styles.sidebarOpenCloseBtn}
        onClick={toggleSidebarcollapse}
      >
        {isCollapsed ? (
          <ChevronRightIcon className="tw-w-6" />
        ) : (
          <ChevronLeftIcon className="tw-w-6" />
        )}
      </button>
      <div className={styles.sidebar} data-collapse={isCollapsed}>
        <ul className={styles.sidebarList}>
          <NavLinks />
        </ul>
        <SponsorLogosSidenav isCollapsed={isCollapsed} />
      </div>
    </div>
  );
};

export default Sidebar;
